// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import Box from "@mui/material/Box";
// import Tab from "@mui/material/Tab";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
// import { BASE_URL } from "../../../Api/ApiFunctions";
// import "./TabSection.css";
// import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

// const SCROLL_SPEED = 1.5; // Adjust marquee scroll speed as needed

// // Convert an API date value (YYYY-MM-DD, ISO, YYYY/M/D, DD-MM-YYYY, DD/MM/YYYY, "10 Sep 2026",
// // epoch ms ...) to a local date-only value (00:00). Returns null if it can't be parsed.
// const toDateOnly = (value) => {
//   if (value === null || value === undefined || value === "") return null;

//   const dateOnly = (d) => (isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate()));
//   if (typeof value === "number") return dateOnly(new Date(value));

//   const str = String(value).trim();

//   let m = str.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
//   if (m) return new Date(+m[1], +m[2] - 1, +m[3]);

//   m = str.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);
//   if (m) return new Date(+m[3], +m[2] - 1, +m[1]);

//   return dateOnly(new Date(str));
// };

// // Latest Uploads rows come from a DB function, so the date column name can vary.
// // Try the known names first, then any other "...date..." column (but never an end/expiry date).
// const UPLOAD_DATE_KEYS = [
//   "u_startdate", "createddate", "u_createddate", "created_date", "u_created_date",
//   "startdate", "start_date", "u_date", "date", "createdon", "created_at",
// ];
// const getUploadDate = (item) => {
//   for (const k of UPLOAD_DATE_KEYS) {
//     if (item[k] && toDateOnly(item[k])) return item[k];
//   }
//   for (const k of Object.keys(item)) {
//     if (/date/i.test(k) && !/end|expir/i.test(k) && item[k] && toDateOnly(item[k])) return item[k];
//   }
//   return null;
// };

// // Split items into current (today + future) and archived (past, newest first).
// // Items with a missing/unparsable date stay in "current" so nothing disappears by mistake.
// const splitByDate = (items, getStartDate, selectedLanguage) => {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);

//   const current = [];
//   const archived = [];

//   (items || [])
//     .filter((item) => !item.u_languagetype || parseInt(item.u_languagetype) === parseInt(selectedLanguage))
//     .forEach((item) => {
//       const d = toDateOnly(getStartDate(item));
//       if (d && d < today) archived.push({ item, d });
//       else current.push(item);
//     });

//   archived.sort((a, b) => b.d - a.d);
//   return { current, archived: archived.map((a) => a.item) };
// };

// const TabSection = ({
//   value,
//   handleChange,
//   reportData,
//   linkData,
//   tenderData,
//   isPaused,
//   setIsPaused,
//   selectedLanguage,
// }) => {
//   const animationFrameId = useRef(null);
//   const [showArchive, setShowArchive] = useState(false);
//   const [archiveTab, setArchiveTab] = useState("report"); // which tab's archive the modal shows: "report" | "link" | "tender"

//   // News: current (today + future) vs archived (past)
//   const { current: currentNews, archived: archivedNews } = useMemo(
//     () => splitByDate(reportData, (item) => item.u_startdate, selectedLanguage),
//     [reportData, selectedLanguage]
//   );

//   // Latest Uploads: same logic (date is read via getUploadDate)
//   const { current: currentUploads, archived: archivedUploads } = useMemo(
//     () => splitByDate(linkData, getUploadDate, selectedLanguage),
//     [linkData, selectedLanguage]
//   );

//   // Tenders: same logic (date is read via u_startdate)
//   const { current: currentTenders, archived: archivedTenders } = useMemo(
//     () => splitByDate(tenderData, (item) => item.u_startdate, selectedLanguage),
//     [tenderData, selectedLanguage]
//   );

//   // Helps debugging: tell us if some Latest Uploads items have no readable date (they stay visible)
//   useEffect(() => {
//     const undated = (linkData || []).filter((item) => !getUploadDate(item));
//     if (undated.length > 0) {
//       console.warn(
//         `[Latest Uploads] ${undated.length} item(s) have no readable date and stay in the main list. Fields:`,
//         Object.keys(undated[0])
//       );
//     }
//   }, [linkData]);

//   // Separate refs for each tab's scrolling container (for vertical marquee)
//   const marqueeRefs = {
//     1: useRef(null),
//     2: useRef(null),
//     3: useRef(null),
//   };

//   // Scroll marquee animation using requestAnimationFrame
//   useEffect(() => {
//     const step = () => {
//       if (!isPaused && marqueeRefs[value].current) {
//         const el = marqueeRefs[value].current;
//         const scrollHeight = el.scrollHeight;
//         const clientHeight = el.clientHeight;
//         let currentScrollTop = el.scrollTop;
//         let newScrollTop = currentScrollTop + SCROLL_SPEED;

//         if (newScrollTop >= scrollHeight - clientHeight) {
//           newScrollTop = 0; // loop scroll to top
//         }
//         el.scrollTop = newScrollTop;
//       }
//       animationFrameId.current = requestAnimationFrame(step);
//     };

//     animationFrameId.current = requestAnimationFrame(step);

//     return () => cancelAnimationFrame(animationFrameId.current);
//   }, [isPaused, value]);

//   // Render individual list items based on type and language
//   const renderListItem = (item, type) => {
//     let title = "";
//     let startDate = "";
//     let contentType = 1;
//     let keys = {};

//     switch (type) {
//       case "report":
//         title = item.u_report_tittle || item.u_news_tittle || "";
//         startDate = item.u_startdate;
//         contentType = parseInt(item.u_contenttype);
//         keys = {
//           id: item.u_id,
//           pdfPath: item.filepdfpath,
//           internalLink: item.u_internal_link,
//           externalLink: item.u_external_link,
//           menuURL: item.u_menu_url,
//         };
//         break;
//       case "link":
//         title = item.u_menu_name || item.u_news_tittle || "";
//         startDate = item.u_startdate || item.createddate || getUploadDate(item);
//         contentType = parseInt(item.u_content_type || item.u_contenttype);
//         keys = {
//           id: item.u_id,
//           file: item.u_file,
//           internalLink: item.u_internal_link,
//           externalLink: item.u_external_link,
//           menuURL: item.u_menu_url,
//         };
//         break;
//       case "tender":
//         title = item.u_tender_tittle || item.u_tender_tittl || item.u_news_tittle || "";
//         startDate = item.u_startdate;
//         contentType = parseInt(item.u_contenttype);
//         keys = {
//           id: item.u_id,
//           pdfPath: item.filepdfpath,
//           internalFile: item.u_internale_file,
//           externalFile: item.u_external_file,
//           menuURL: item.u_menu_url,
//         };
//         break;
//       default:
//         break;
//     }

//     // Language filter — show only items matching selectedLanguage
//     if (item.u_languagetype && parseInt(item.u_languagetype) !== parseInt(selectedLanguage)) {
//       return null;
//     }

//     const renderLink = () => {
//       switch (contentType) {
//         case 2:
//           return (
//             <Link
//               to={BASE_URL + (keys.pdfPath || keys.file || "")}
//               target="_blank"
//               rel="noopener noreferrer"
//               aria-label={`Download: ${title}`}
//             >
//               {title}
//             </Link>
//           );
//         case 3:
//           return (
//             <Link
//               to={keys.internalLink || keys.internalFile || "#"}
//               style={{ textDecoration: "none" }}
//               aria-label={`View: ${title}`}
//             >
//               {title}
//             </Link>
//           );
//         case 4:
//           return (
//             <a
//               href={keys.externalLink || keys.externalFile || "#"}
//               target="_blank"
//               rel="noopener noreferrer"
//               aria-label={`Visit External Link: ${title}`}
//             >
//               {title}
//             </a>
//           );
//         case 1:
//         default:
//           return (
//             <Link to={`/menu/${keys.menuURL || ""}`} aria-label={`View Menu: ${title}`}>
//               {title}
//             </Link>
//           );
//       }
//     };

//     return (
//       <li key={keys.id || title} className="newsbox" style={{ padding: "5px 0" }}>
//         <div className="latest-news-date" style={{ marginBottom: "3px" }}>
//           <p className="news-sec-datep">{startDate}</p>
//         </div>
//         <div className="ml-10">
//           <p className="news-p">{renderLink()}</p>
//         </div>
//       </li>
//     );
//   };

//   // Render filtered list items for each tab based on current tab value
//   const renderListByTab = () => {
//     switch (value) {
//       case "1": // समाचार / News
//         return currentNews.length > 0 ? (
//           currentNews.map((item) => renderListItem(item, "report"))
//         ) : (
//           <li className="text-muted text-center py-3">{tabLabels.noNews}</li>
//         );
//       case "2": // नवीनतम अपलोड / Latest Uploads
//         return currentUploads.length > 0 ? (
//           currentUploads.map((item) => renderListItem(item, "link"))
//         ) : (
//           <li className="text-muted text-center py-3">{tabLabels.noUploads}</li>
//         );
//       case "3": // निविदाओं / Tenders
//         return currentTenders.length > 0 ? (
//           currentTenders.map((item) => renderListItem(item, "tender"))
//         ) : (
//           <li className="text-muted text-center py-3">{tabLabels.noTenders}</li>
//         );
//       default:
//         return null;
//     }
//   };

//   // Define tab labels dynamically based on selected language
//   const tabLabels =
//     selectedLanguage === 1
//       ? {
//           news: "News", uploads: "Latest Uploads", tenders: "Tenders", play: "▶️", pause: "⏸️",
//           archives: "Archives", archiveTitle: "News Archives", noNews: "No current news.", noArchive: "No archived news.", close: "Close",
//           archiveTitleUploads: "Latest Uploads Archives", noUploads: "No current uploads.", noArchiveUploads: "No archived uploads.",
//           archiveTitleTenders: "Tenders Archives", noTenders: "No current tenders.", noArchiveTenders: "No archived tenders.",
//         }
//       : {
//           news: "समाचार", uploads: "नवीनतम अपलोड", tenders: "निविदाओं", play: "▶️", pause: "⏸️",
//           archives: "अभिलेखागार", archiveTitle: "समाचार अभिलेखागार", noNews: "कोई वर्तमान समाचार नहीं।", noArchive: "कोई संग्रहीत समाचार नहीं।", close: "बंद करें",
//           archiveTitleUploads: "नवीनतम अपलोड अभिलेखागार", noUploads: "कोई वर्तमान अपलोड नहीं।", noArchiveUploads: "कोई संग्रहीत अपलोड नहीं।",
//           archiveTitleTenders: "निविदा अभिलेखागार", noTenders: "कोई वर्तमान निविदा नहीं।", noArchiveTenders: "कोई संग्रहीत निविदा नहीं।",
//         };

//   // Items shown inside the Archives modal (depends on which tab's button was clicked)
//   const archiveItems =
//     archiveTab === "link" ? archivedUploads
//     : archiveTab === "tender" ? archivedTenders
//     : archivedNews;

//   return (
//     <Box className="main-box1" sx={{ width: "100%", typography: "body1" }} bgcolor={"#00000"}>
//       <TabContext value={value}>
//         <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//           <TabList onChange={handleChange} aria-label="Tabs for News, Latest Uploads, and Tenders">
//             <Tab label={tabLabels.news} value="1" className="custom-tab" />
//             <Tab label={tabLabels.uploads} value="2" className="custom-tab" />
//             <Tab label={tabLabels.tenders} value="3" className="custom-tab" />
//             <div className="d-flex justify-content-end">
//                <OverlayTrigger
//                               placement="top"
//                               overlay={<Tooltip id="tooltip-national-emblem">Click to Play/Pause</Tooltip>}
//                             >
//               <button onClick={() => setIsPaused((prev) => !prev)} className="btn-sm btn-primary me-2">
//                 {isPaused ? tabLabels.play : tabLabels.pause}
//               </button>
//               </OverlayTrigger>
//             </div>
//           </TabList>
//         </Box>

//         <TabPanel value="1" className="bg-light">
//           <div
//             className="marquee-container1 marquee1 vertical-marquee"
//             aria-live="polite"
//             ref={marqueeRefs[1]}
//             tabIndex={0}
//             style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
//           >
//             <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <button
//               type="button"
//               className="btn btn-sm btn-primary"
//               onClick={() => { setArchiveTab("report"); setShowArchive(true); }}
//               aria-haspopup="dialog"
//             >
//               <i className="bi bi-archive me-1" aria-hidden="true"></i>
//               {tabLabels.archives}
//             </button>
//           </div>
//         </TabPanel>

//         <TabPanel value="2" className="bg-light">
//           <div
//             className="marquee-container1 marquee1 vertical-marquee"
//             aria-live="polite"
//             ref={marqueeRefs[2]}
//             tabIndex={0}
//             style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
//           >
//             <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <button
//               type="button"
//               className="btn btn-sm btn-primary"
//               onClick={() => { setArchiveTab("link"); setShowArchive(true); }}
//               aria-haspopup="dialog"
//             >
//               <i className="bi bi-archive me-1" aria-hidden="true"></i>
//               {tabLabels.archives}
//             </button>
//           </div>
//         </TabPanel>

//         <TabPanel value="3" className="bg-light">
//           <div
//             className="marquee-container1 marquee1 vertical-marquee"
//             aria-live="polite"
//             ref={marqueeRefs[3]}
//             tabIndex={0}
//             style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
//           >
//             <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <button
//               type="button"
//               className="btn btn-sm btn-primary"
//               onClick={() => { setArchiveTab("tender"); setShowArchive(true); }}
//               aria-haspopup="dialog"
//             >
//               <i className="bi bi-archive me-1" aria-hidden="true"></i>
//               {tabLabels.archives}
//             </button>
//           </div>
//         </TabPanel>
//       </TabContext>

//       {/* Archives modal: all past News / Latest Uploads / Tenders */}
//       <Modal show={showArchive} onHide={() => setShowArchive(false)} centered scrollable size="lg" className="news-archive-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {archiveTab === "link"
//               ? tabLabels.archiveTitleUploads
//               : archiveTab === "tender"
//               ? tabLabels.archiveTitleTenders
//               : tabLabels.archiveTitle}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {archiveItems.length > 0 ? (
//             <ul className="report-sec news-archive-list">
//               {archiveItems.map((item) => renderListItem(item, archiveTab))}
//             </ul>
//           ) : (
//             <p className="text-muted text-center mb-0">
//               {archiveTab === "link"
//                 ? tabLabels.noArchiveUploads
//                 : archiveTab === "tender"
//                 ? tabLabels.noArchiveTenders
//                 : tabLabels.noArchive}
//             </p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <button type="button" className="btn btn-sm btn-secondary" onClick={() => setShowArchive(false)}>
//             {tabLabels.close}
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </Box>
//   );
// };

// export default TabSection;



import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { BASE_URL } from "../../../Api/ApiFunctions";
import "./TabSection.css";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

const SCROLL_SPEED = 1.5; // Adjust marquee scroll speed as needed

// Convert an API date value (YYYY-MM-DD, ISO, YYYY/M/D, DD-MM-YYYY, DD/MM/YYYY, "10 Sep 2026",
// epoch ms ...) to a local date-only value (00:00). Returns null if it can't be parsed.
const toDateOnly = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const dateOnly = (d) => (isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate()));
  if (typeof value === "number") return dateOnly(new Date(value));

  const str = String(value).trim();

  let m = str.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);

  m = str.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]);

  return dateOnly(new Date(str));
};

// Latest Uploads rows come from a DB function, so the date column name can vary.
// Try the known names first, then any other "...date..." column (but never an end/expiry date).
const UPLOAD_DATE_KEYS = [
  "u_startdate", "createddate", "u_createddate", "created_date", "u_created_date",
  "startdate", "start_date", "u_date", "date", "createdon", "created_at",
];
const getUploadDate = (item) => {
  for (const k of UPLOAD_DATE_KEYS) {
    if (item[k] && toDateOnly(item[k])) return item[k];
  }
  for (const k of Object.keys(item)) {
    if (/date/i.test(k) && !/end|expir/i.test(k) && item[k] && toDateOnly(item[k])) return item[k];
  }
  return null;
};

// Split items into current (today + future) and archived (past, newest first).
// Items with a missing/unparsable date stay in "current" so nothing disappears by mistake.
const splitByDate = (items, getStartDate, selectedLanguage) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const current = [];
  const archived = [];

  (items || [])
    .filter((item) => !item.u_languagetype || parseInt(item.u_languagetype) === parseInt(selectedLanguage))
    .forEach((item) => {
      const d = toDateOnly(getStartDate(item));
      if (d && d < today) archived.push({ item, d });
      else current.push(item);
    });

  archived.sort((a, b) => b.d - a.d);
  return { current, archived: archived.map((a) => a.item) };
};

const TabSection = ({
  value,
  handleChange,
  reportData,
  linkData,
  tenderData,
  isPaused,
  setIsPaused,
  selectedLanguage,
}) => {
  const animationFrameId = useRef(null);
  const [showArchive, setShowArchive] = useState(false);
  const [archiveTab, setArchiveTab] = useState("report"); // which tab's archive the modal shows: "report" | "link" | "tender"

  // News: current (today + future) vs archived (past)
  const { current: currentNews, archived: archivedNews } = useMemo(
    () => splitByDate(reportData, (item) => item.u_startdate, selectedLanguage),
    [reportData, selectedLanguage]
  );

  // Latest Uploads: same logic (date is read via getUploadDate)
  const { current: currentUploads, archived: archivedUploads } = useMemo(
    () => splitByDate(linkData, getUploadDate, selectedLanguage),
    [linkData, selectedLanguage]
  );

  // Tenders: same logic (date is read via u_startdate)
  const { current: currentTenders, archived: archivedTenders } = useMemo(
    () => splitByDate(tenderData, (item) => item.u_startdate, selectedLanguage),
    [tenderData, selectedLanguage]
  );

  // Helps debugging: tell us if some Latest Uploads items have no readable date (they stay visible)
  useEffect(() => {
    const undated = (linkData || []).filter((item) => !getUploadDate(item));
    if (undated.length > 0) {
      console.warn(
        `[Latest Uploads] ${undated.length} item(s) have no readable date and stay in the main list. Fields:`,
        Object.keys(undated[0])
      );
    }
  }, [linkData]);

  // Separate refs for each tab's scrolling container (for vertical marquee)
  const marqueeRefs = {
    1: useRef(null),
    2: useRef(null),
    3: useRef(null),
  };

  // Scroll marquee animation using requestAnimationFrame
  useEffect(() => {
    const step = () => {
      if (!isPaused && marqueeRefs[value].current) {
        const el = marqueeRefs[value].current;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;
        let currentScrollTop = el.scrollTop;
        let newScrollTop = currentScrollTop + SCROLL_SPEED;

        if (newScrollTop >= scrollHeight - clientHeight) {
          newScrollTop = 0; // loop scroll to top
        }
        el.scrollTop = newScrollTop;
      }
      animationFrameId.current = requestAnimationFrame(step);
    };

    animationFrameId.current = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrameId.current);
  }, [isPaused, value]);

  // Render individual list items based on type and language
  const renderListItem = (item, type) => {
    let title = "";
    let startDate = "";
    let contentType = 1;
    let keys = {};

    switch (type) {
      case "report":
        title = item.u_report_tittle || item.u_news_tittle || "";
        startDate = item.u_startdate;
        contentType = parseInt(item.u_content_type || item.u_contenttype);
        keys = {
          id: item.u_id,
          pdfPath: item.filepdfpath,
          file: item.u_file,
          internalLink: item.u_internal_link,
          externalLink: item.u_external_link,
          menuURL: item.u_menu_url,
        };
        break;
      case "link":
        title = item.u_menu_name || item.u_news_tittle || "";
        startDate = item.u_startdate || item.createddate || getUploadDate(item);
        contentType = parseInt(item.u_content_type || item.u_contenttype);
        keys = {
          id: item.u_id,
          file: item.u_file,
          pdfPath: item.filepdfpath,
          internalLink: item.u_internal_link,
          externalLink: item.u_external_link,
          menuURL: item.u_menu_url,
        };
        break;
      case "tender":
        title = item.u_tender_tittle || item.u_tender_tittl || item.u_news_tittle || "";
        startDate = item.u_startdate;
        contentType = parseInt(item.u_content_type || item.u_contenttype);
        keys = {
          id: item.u_id,
          pdfPath: item.filepdfpath,
          file: item.u_file,
          internalFile: item.u_internale_file,
          externalFile: item.u_external_file,
          internalLink: item.u_internal_link,
          externalLink: item.u_external_link,
          menuURL: item.u_menu_url,
        };
        break;
      default:
        break;
    }

    // Language filter — show only items matching selectedLanguage
    if (item.u_languagetype && parseInt(item.u_languagetype) !== parseInt(selectedLanguage)) {
      return null;
    }

    const renderLink = () => {
      switch (contentType) {
        case 2: {
          // PDF / file download — use <a> instead of <Link> so it works on c4k (production build)
          const fileUrl = BASE_URL + (keys.pdfPath || keys.file || "");
          return (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Download: ${title}`}
            >
              {title}
            </a>
          );
        }
        case 3: {
          // Internal link / file — if it's a full URL use <a>, otherwise use <Link> for SPA routing
          const internalUrl = keys.internalLink || keys.internalFile || "#";
          if (/^https?:\/\//i.test(internalUrl) || /^data:/i.test(internalUrl)) {
            return (
              <a
                href={internalUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                aria-label={`View: ${title}`}
              >
                {title}
              </a>
            );
          }
          // If it looks like a file path (has extension), use <a> with BASE_URL
          if (keys.internalFile && !/^\/?menu\//i.test(internalUrl)) {
            return (
              <a
                href={BASE_URL + keys.internalFile}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                aria-label={`View: ${title}`}
              >
                {title}
              </a>
            );
          }
          return (
            <Link
              to={internalUrl}
              style={{ textDecoration: "none" }}
              aria-label={`View: ${title}`}
            >
              {title}
            </Link>
          );
        }
        case 4:
          return (
            <a
              href={keys.externalLink || keys.externalFile || "#"}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit External Link: ${title}`}
            >
              {title}
            </a>
          );
        case 1:
        default:
          return (
            <Link to={`/menu/${keys.menuURL || ""}`} aria-label={`View Menu: ${title}`}>
              {title}
            </Link>
          );
      }
    };

    return (
      <li key={keys.id || title} className="newsbox" style={{ padding: "5px 0" }}>
        <div className="latest-news-date" style={{ marginBottom: "3px" }}>
          <p className="news-sec-datep">{startDate}</p>
        </div>
        <div className="ml-10">
          <p className="news-p">{renderLink()}</p>
        </div>
      </li>
    );
  };

  // Render filtered list items for each tab based on current tab value
  const renderListByTab = () => {
    switch (value) {
      case "1": // समाचार / News
        return currentNews.length > 0 ? (
          currentNews.map((item) => renderListItem(item, "report"))
        ) : (
          <li className="text-muted text-center py-3">{tabLabels.noNews}</li>
        );
      case "2": // नवीनतम अपलोड / Latest Uploads
        return currentUploads.length > 0 ? (
          currentUploads.map((item) => renderListItem(item, "link"))
        ) : (
          <li className="text-muted text-center py-3">{tabLabels.noUploads}</li>
        );
      case "3": // निविदाओं / Tenders
        return currentTenders.length > 0 ? (
          currentTenders.map((item) => renderListItem(item, "tender"))
        ) : (
          <li className="text-muted text-center py-3">{tabLabels.noTenders}</li>
        );
      default:
        return null;
    }
  };

  // Define tab labels dynamically based on selected language
  const tabLabels =
    selectedLanguage === 1
      ? {
          news: "News", uploads: "Latest Uploads", tenders: "Tenders", play: "▶️", pause: "⏸️",
          archives: "Archives", archiveTitle: "News Archives", noNews: "No current news.", noArchive: "No archived news.", close: "Close",
          archiveTitleUploads: "Latest Uploads Archives", noUploads: "No current uploads.", noArchiveUploads: "No archived uploads.",
          archiveTitleTenders: "Tenders Archives", noTenders: "No current tenders.", noArchiveTenders: "No archived tenders.",
        }
      : {
          news: "समाचार", uploads: "नवीनतम अपलोड", tenders: "निविदाओं", play: "▶️", pause: "⏸️",
          archives: "अभिलेखागार", archiveTitle: "समाचार अभिलेखागार", noNews: "कोई वर्तमान समाचार नहीं।", noArchive: "कोई संग्रहीत समाचार नहीं।", close: "बंद करें",
          archiveTitleUploads: "नवीनतम अपलोड अभिलेखागार", noUploads: "कोई वर्तमान अपलोड नहीं।", noArchiveUploads: "कोई संग्रहीत अपलोड नहीं।",
          archiveTitleTenders: "निविदा अभिलेखागार", noTenders: "कोई वर्तमान निविदा नहीं।", noArchiveTenders: "कोई संग्रहीत निविदा नहीं।",
        };

  // Items shown inside the Archives modal (depends on which tab's button was clicked)
  const archiveItems =
    archiveTab === "link" ? archivedUploads
    : archiveTab === "tender" ? archivedTenders
    : archivedNews;

  return (
    <Box className="main-box1" sx={{ width: "100%", typography: "body1" }} bgcolor={"#00000"}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Tabs for News, Latest Uploads, and Tenders">
            <Tab label={tabLabels.news} value="1" className="custom-tab" />
            <Tab label={tabLabels.uploads} value="2" className="custom-tab" />
            <Tab label={tabLabels.tenders} value="3" className="custom-tab" />
            <div className="d-flex justify-content-end">
               <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip-national-emblem">Click to Play/Pause</Tooltip>}
                            >
              <button onClick={() => setIsPaused((prev) => !prev)} className="btn-sm btn-primary me-2">
                {isPaused ? tabLabels.play : tabLabels.pause}
              </button>
              </OverlayTrigger>
            </div>
          </TabList>
        </Box>

        <TabPanel value="1" className="bg-light">
          <div
            className="marquee-container1 marquee1 vertical-marquee"
            aria-live="polite"
            ref={marqueeRefs[1]}
            tabIndex={0}
            style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
          >
            <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
          </div>
          <div className="d-flex justify-content-end mt-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => { setArchiveTab("report"); setShowArchive(true); }}
              aria-haspopup="dialog"
            >
              <i className="bi bi-archive me-1" aria-hidden="true"></i>
              {tabLabels.archives}
            </button>
          </div>
        </TabPanel>

        <TabPanel value="2" className="bg-light">
          <div
            className="marquee-container1 marquee1 vertical-marquee"
            aria-live="polite"
            ref={marqueeRefs[2]}
            tabIndex={0}
            style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
          >
            <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
          </div>
          <div className="d-flex justify-content-end mt-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => { setArchiveTab("link"); setShowArchive(true); }}
              aria-haspopup="dialog"
            >
              <i className="bi bi-archive me-1" aria-hidden="true"></i>
              {tabLabels.archives}
            </button>
          </div>
        </TabPanel>

        <TabPanel value="3" className="bg-light">
          <div
            className="marquee-container1 marquee1 vertical-marquee"
            aria-live="polite"
            ref={marqueeRefs[3]}
            tabIndex={0}
            style={{ willChange: "scroll-position", maxHeight: "500px", overflowY: "auto" }}
          >
            <ul className={`marquee-list report-sec ${isPaused ? "paused" : ""}`}>{renderListByTab()}</ul>
          </div>
          <div className="d-flex justify-content-end mt-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => { setArchiveTab("tender"); setShowArchive(true); }}
              aria-haspopup="dialog"
            >
              <i className="bi bi-archive me-1" aria-hidden="true"></i>
              {tabLabels.archives}
            </button>
          </div>
        </TabPanel>
      </TabContext>

      {/* Archives modal: all past News / Latest Uploads / Tenders */}
      <Modal show={showArchive} onHide={() => setShowArchive(false)} centered scrollable size="lg" className="news-archive-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            {archiveTab === "link"
              ? tabLabels.archiveTitleUploads
              : archiveTab === "tender"
              ? tabLabels.archiveTitleTenders
              : tabLabels.archiveTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {archiveItems.length > 0 ? (
            <ul className="report-sec news-archive-list">
              {archiveItems.map((item) => renderListItem(item, archiveTab))}
            </ul>
          ) : (
            <p className="text-muted text-center mb-0">
              {archiveTab === "link"
                ? tabLabels.noArchiveUploads
                : archiveTab === "tender"
                ? tabLabels.noArchiveTenders
                : tabLabels.noArchive}
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm btn-secondary" onClick={() => setShowArchive(false)}>
            {tabLabels.close}
          </button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

export default TabSection;
